/* 무료보험 프로모션 추가부분(7.17 이후 제거) */
export enum PROMOTION_PERIOD_STATUS {
  DONE = '마감',
  PROGRESS = '진행중',
  TODO = '대기중',
  NONE = '',
}

export type PROMOTION_PERIOD_TYPE = {
  week: number
  start: string
  end: string
}

export const PROMOTION_PERIOD: PROMOTION_PERIOD_TYPE[] = [
  {
    week: 1,
    start: '2023-04-24',
    end: '2023-04-30',
  },
  {
    week: 2,
    start: '2023-05-01',
    end: '2023-05-07',
  },
  {
    week: 3,
    start: '2023-05-08',
    end: '2023-05-14',
  },
  {
    week: 4,
    start: '2023-05-15',
    end: '2023-05-21',
  },
  {
    week: 5,
    start: '2023-05-22',
    end: '2023-05-28',
  },
  {
    week: 6,
    start: '2023-05-29',
    end: '2023-06-04',
  },
  {
    week: 7,
    start: '2023-06-05',
    end: '2023-06-11',
  },
  {
    week: 8,
    start: '2023-06-12',
    end: '2023-06-18',
  },
  {
    week: 9,
    start: '2023-06-19',
    end: '2023-06-25',
  },
  {
    week: 10,
    start: '2023-06-26',
    end: '2023-07-02',
  },
]

export enum PROMOTION_FAIL_GUIDE {
  REJECT = '집주인 인증에 성공해야 가입 신청하신 무료 화재보험 혜택을 받을 수 있어요.',
  FAIL = '집주인 인증이 최종 반려되어 신청하신 무료 화재보험 신청이 취소됩니다.',
}

export enum PROMOTION_TOAST {
  LINK_COPY = '무료 화재보험 공유 링크가 복사되었어요.',
  INPUT_ALL_SUBSCRIBER_INFO = '가입자 정보를 모두 입력해 주세요.',
  OWNER_AUTH_FIRST = '집주인 인증부터 진행해 주세요.',
  HOUSE_REGIST_FIRST = '우리집 등록부터 진행해 주세요.',
  ALREADY_AUTH_COMPLETION = '이미 집주인 인증을\n완료해 주셨습니다.',
  ALREADY_AUTH_PROGRESS = '이미 집주인 인증\n진행 중입니다.',
  AGREE_INSURANCE_TERMS = '화재보험 무료가입 동의를 선택해 주세요.',
}

export const PROMOTION_MAX_APPLY_COUNT = 20000
export const PROMOTION_START_DATE = '2023-04-24'
export const PROMOTION_END_DATE = '2023-07-02'
export const PROMOTION_CLOSE_POPUP_DATE = '2023-07-17'
export const LAST_PROMOTION_WEEK_INDEX = 9
export const FIRST_HOUSE_INDEX = 0

export enum PROMOTION_PAGE {
  INFORMATION,
  CONFIRM,
}

export enum PROMOTION_TERMS {
  NONE = '',
  // 1. DB손해보험㈜ 무료 화재보험 서비스 약관
  DB_TERMS_OF_SERVICE = '1',
  // 2. DB손해보험㈜ 개인 신용 정보제공동의
  DB_PROVIDE_PERSONAL_CREDIT_INFORMATION = '2',
  //・ 3. (필수) DB손해보험㈜ 개인정보 처리 동의
  // - 3.1 개인정보 수집 이용 동의
  DB_INFORMATION_COLLECT = '3.1',
  // - 3.2 개인정보 제 3자 제공 동의
  DB_INFORMATION_THIRD_PARTY_PROVIDE = '3.2',
  // 4. DB손해보험㈜ 무료 화재보험 가입 동의
  DB_FIRE_INSURANCE_REGISTER = '4',
}

// land-api : com.naver.land.api.entity.inner.myhouse.MyHousePromotionInsuranceApplyResultTypeEnum
export enum PROMOTION_APPLY_RESULT_TYPE {
  NONE,
  NOT_KOREAN,
  NOT_MYHOUSE,
  NOT_DEAL,
  NOT_APARTMENT,
  NOT_COMPLEX,
  NOT_IN_PROMOTION_PERIOD,
  OVER_PROMOTION_PERIOD_APPLIED_COUNT,
  OVER_PROMOTION_TOTAL_APPLIED_COUNT,
  EXISTS_APPLY,
  EXISTS_APPLY_OTHER_ID,
  LOAD_PAY_MEMBER_FAILED,
  NOT_AUTHENTICATION_APPLY,
  AUTHENTICATION_FAILED,
  OK_PRE_AUTH,
  OK,
}

type PromotionApplyResultType = {
  code: string
  result: boolean
  comment: string
}
export const PROMOTION_APPLY_RESULT_TYPE_INFO: Record<PROMOTION_APPLY_RESULT_TYPE, PromotionApplyResultType> = {
  [PROMOTION_APPLY_RESULT_TYPE.NONE]: { code: 'NONE', result: false, comment: '' },
  [PROMOTION_APPLY_RESULT_TYPE.NOT_KOREAN]: { code: 'NOT_KOREAN', result: false, comment: '외국인' },
  [PROMOTION_APPLY_RESULT_TYPE.NOT_MYHOUSE]: { code: 'NOT_MYHOUSE', result: false, comment: '우리집 아님' },
  [PROMOTION_APPLY_RESULT_TYPE.NOT_DEAL]: { code: 'NOT_DEAL', result: false, comment: '매매 아님' },
  [PROMOTION_APPLY_RESULT_TYPE.NOT_APARTMENT]: { code: 'NOT_APARTMENT', result: false, comment: '아파트 아님' },
  [PROMOTION_APPLY_RESULT_TYPE.NOT_COMPLEX]: { code: 'NOT_COMPLEX', result: false, comment: '단지 아님' },
  [PROMOTION_APPLY_RESULT_TYPE.NOT_IN_PROMOTION_PERIOD]: { code: 'NOT_IN_PROMOTION_PERIOD', result: false, comment: '프로모션 기간 아님' },
  [PROMOTION_APPLY_RESULT_TYPE.OVER_PROMOTION_PERIOD_APPLIED_COUNT]: { code: 'OVER_PROMOTION_PERIOD_APPLIED_COUNT', result: false, comment: '해당 주차 카운트 초과' },
  [PROMOTION_APPLY_RESULT_TYPE.OVER_PROMOTION_TOTAL_APPLIED_COUNT]: { code: 'OVER_PROMOTION_TOTAL_APPLIED_COUNT', result: false, comment: '전체 카운트 초과' },
  [PROMOTION_APPLY_RESULT_TYPE.EXISTS_APPLY]: { code: 'EXISTS_APPLY', result: false, comment: '신청 이력 존재' },
  [PROMOTION_APPLY_RESULT_TYPE.EXISTS_APPLY_OTHER_ID]: { code: 'EXISTS_APPLY_OTHER_ID', result: false, comment: '다른 아이디에 신청 이력 존재' },
  [PROMOTION_APPLY_RESULT_TYPE.LOAD_PAY_MEMBER_FAILED]: { code: 'LOAD_PAY_MEMBER_FAILED', result: false, comment: '페이 회원 정보 로드 실패' },
  [PROMOTION_APPLY_RESULT_TYPE.NOT_AUTHENTICATION_APPLY]: { code: 'NOT_AUTHENTICATION_APPLY', result: false, comment: '집주인 인증 및 신청 이력 없음' },
  [PROMOTION_APPLY_RESULT_TYPE.AUTHENTICATION_FAILED]: { code: 'AUTHENTICATION_FAILED', result: false, comment: '집주인 인증 최종 실패 상태' },
  [PROMOTION_APPLY_RESULT_TYPE.OK_PRE_AUTH]: { code: 'OK_PRE_AUTH', result: true, comment: '집주인 인증자 가입 성공' },
  [PROMOTION_APPLY_RESULT_TYPE.OK]: { code: 'OK', result: true, comment: '성공' },
}
